import { ReactNode, useEffect, useState } from "react";
import bg from "../assets/images/bg.svg";
import { IconButton, Menu, MenuItem } from "@mui/material";
import LanguageRounded from "@mui/icons-material/LanguageRounded";
import { useTranslation } from "react-i18next";

type AuthLayoutProps = {
  children?: ReactNode;
  title?: string;
  subTitle?: string;
};

const AuthLayout = ({ children, title, subTitle }: AuthLayoutProps) => {
  const { t, i18n } = useTranslation(["home"]);

  const [anchorLanguage, setAnchorLanguage] = useState<null | HTMLElement>(
    null
  );
  const open = Boolean(anchorLanguage);

  useEffect(() => {
    setLanguage();
  }, []);
  const setLanguage = async () => {
    const lang = await localStorage.getItem("language");
    if (lang) {
      i18n.changeLanguage(lang);
    }
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorLanguage(event.currentTarget);
  };
  const handleLanguageClose = () => {
    setAnchorLanguage(null);
  };

  const handleLanguage = (lang: string) => {
    i18n.changeLanguage(lang);
    localStorage.setItem("language", lang);
    handleLanguageClose();
  };

  return (
    <div
      style={{ backgroundImage: `url('${bg}')` }}
      className="h-[100vh] w-full bg-cover"
    >
      <div className="flex items-center pl-3 pt-3 absolute">
        <p className="text-white">Change Language</p>
        <div>
          <IconButton
            aria-label="more"
            id="long-button"
            aria-controls={open ? "long-menu" : undefined}
            aria-expanded={open ? "true" : undefined}
            aria-haspopup="true"
            onClick={handleClick}
          >
            <LanguageRounded />
          </IconButton>

          <Menu
            id="basic-menu"
            anchorEl={anchorLanguage}
            open={open}
            onClose={handleLanguageClose}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
          >
            <MenuItem onClick={() => handleLanguage("en")}>English</MenuItem>
            <MenuItem onClick={() => handleLanguage("ce")}>Chinese</MenuItem>
          </Menu>
        </div>
      </div>
      <div className="h-full flex items-center">
        <div className="bg-white rounded w-[90%] sm:w-[60%] md:w-[40%] pt-8 mx-auto  ">
          <div className=" pb-5  border-b border-lightGrey text-center">
            <h1 className="text-lg text-darkBlack font-bold ">{title}</h1>
            <p className="text-sm text-grey mt-2">{subTitle}</p>
          </div>
          <div className="pb-8 px-7 mt-4">{children}</div>
        </div>
      </div>
    </div>
  );
};
export default AuthLayout;
